import { render, staticRenderFns } from "./ReservationForm.vue?vue&type=template&id=660f136c"
import script from "./ReservationForm.vue?vue&type=script&lang=ts"
export * from "./ReservationForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports